package com.evoapps.evoshift.domain.provider

/**
 * The platform's "Sign in with Apple" (SH-92, App Store guideline 4.8): Apple's native sheet on
 * iOS, Firebase's apple.com OAuth flow on Android (a Custom Tab) and on the web (a popup)
 * (composeApp, `AppleSignInClient.*.kt`; docs/apple-sign-in.md).
 */
interface AppleSignInClient {
    /** Whether this platform offers Sign in with Apple; the buttons are hidden otherwise. */
    val isAvailable: Boolean

    /** Shows Apple's sheet; null when the person backs out. */
    suspend fun signIn(): AppleSignIn?
}

/** What a finished Apple sheet hands to `AuthRepository.signInWithApple`. */
sealed interface AppleSignIn {
    /** The name Apple shares only on the first authorization (null afterwards or when hidden). */
    val fullName: String?

    /**
     * The native sheet (iOS): Firebase still has to be signed in with Apple's [idToken] and the
     * [rawNonce] whose SHA-256 the sheet was given. [authorizationCode] lets the server obtain a
     * refresh token, which account deletion revokes (functions/appleAuth.js).
     */
    data class Credential(
        val idToken: String,
        val rawNonce: String,
        val authorizationCode: String? = null,
        override val fullName: String? = null
    ) : AppleSignIn

    /** Firebase's own OAuth flow (Android, web) or the Mac app's browser flow has already signed in. */
    data class SignedIn(override val fullName: String? = null) : AppleSignIn
}
